import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import SearchInput from '@/components/common/search-input';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import SessionList from '@/components/sessions/session-list/session-list';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';

export default function MessagesIndexRoute() {
  const { t } = useTranslation();
  const { isEmbedded } = useUserPlatform();

  return (
    <PageLayout
      title={t('nav.messages')}
      className='gap-0 desktop:flex-1 desktop:border-r desktop:border-neutral-300 pb-safe-offset-16 desktop:pb-0'
      headerConfig={{
        headerLabel: t('nav.messages'),
        actions: <AppHeaderMenu />,
        showHeader: !isEmbedded,
        elementAfterNav: (
          <Link
            className='mx-3 block'
            to={ROUTES.SEARCH.$path()}>
            <SearchInput
              className='pointer-events-none'
              keyword=''
            />
          </Link>
        ),
      }}>
      <SessionList />
    </PageLayout>
  );
}
